import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import Logo from './Logo';
import { contactInfo } from '../data/mockData';

const Footer = () => {
  const { owner, phone, whatsapp, address } = contactInfo;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <Logo variant="light" className="mb-6" />
            <p className="text-gray-400 leading-relaxed mb-4">
              Jabalpur's largest fabric wholesaler supplying premium quality fabrics for sportswear, garments, and fashion.
            </p>
            <p className="text-sm text-gray-500">
              Trusted by manufacturers since 2005
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-gray-400 hover:text-accent transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#products" className="text-gray-400 hover:text-accent transition-colors">
                  Products
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-accent transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-accent transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-bold mb-6">Popular Fabrics</h3>
            <ul className="space-y-3 text-gray-400">
              <li>4-Way Zurich Fabric</li>
              <li>Superpoly Fabric</li>
              <li>Honeycomb Fabric</li>
              <li>Hosiery Fabric</li>
              <li>Cotton Fabric</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-accent flex-shrink-0 mt-1" />
                <span className="text-gray-400 text-sm">
                  {address.line1}, {address.line2}, {address.line3}, {address.state} - {address.pincode}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-accent" />
                <a href={`tel:${phone}`} className="text-gray-400 hover:text-accent transition-colors">
                  +91 9713889720 (Call / WhatsApp)
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} ARIHANT SALES. All rights reserved. | Owner: {owner}
            </p>
            <div className="flex flex-col md:flex-row items-center gap-4 text-gray-400 text-sm">
              <p>Fabric Wholesaler in Jabalpur | Wholesale Fabric Supplier MP</p>
              <span className="hidden md:inline">|</span>
              <p>Developed by <a href="mailto:jtaru28912@gmail.com" className="text-accent hover:text-accent-light transition-colors">Taru Jain</a> - Email: <a href="mailto:jtaru28912@gmail.com" className="text-accent hover:text-accent-light transition-colors">jtaru28912@gmail.com</a></p>
            </div>
          </div>
        </div>
      </div>

      {/* Invisible SEO Keywords for Search Ranking - Trade/B2B Focus */}
      <div className="sr-only" aria-hidden="true">
        fabric wholesale dealer India, fabric bulk supplier India, fabric roll supplier India,
        fabric for garment manufacturing, fabric supplier for factories, fabric sourcing India,
        220 GSM fabric wholesale India, 260 GSM fabric supplier, 240 GSM fabric wholesale,
        polyester fabric wholesale India, poly spandex fabric wholesale, 92 polyester 8 spandex fabric,
        fabric for t-shirt manufacturing, fabric for track pants wholesale, fabric for gym wear supplier,
        fabric for sportswear manufacturing, fabric for school uniforms bulk, fabric for corporate uniforms,
        lycra fabric wholesale India, performance fabric supplier India, fabric for activewear brands
      </div>
    </footer>
  );
};

export default Footer;
